import { render, staticRenderFns } from "./phelites.vue?vue&type=template&id=54ccaa6a"
import script from "./phelites.vue?vue&type=script&lang=js"
export * from "./phelites.vue?vue&type=script&lang=js"
import style0 from "./phelites.vue?vue&type=style&index=0&id=54ccaa6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports